var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthentication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 201,
    viewBox: "0 0 187 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 186.88C145.106 186.88 186.94 145.046 186.94 93.4401C186.94 41.8346 145.106 0 93.5 0C41.8945 0 0.0599365 41.8346 0.0599365 93.4401C0.0599365 145.046 41.8945 186.88 93.5 186.88Z",
    fill: "#C1E8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.179 85.7268L92.913 79.4812C92.913 79.4812 96.8485 80.6662 101.029 78.5571C105.209 76.448 108.138 73.1105 108.138 73.1105L113.226 84.8952C113.226 84.8952 110.318 92.5215 100.681 92.2062C91.0431 91.8909 91.1736 85.7214 91.1736 85.7214L91.179 85.7268Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8206 124.989C61.8206 124.989 62.549 109.416 67.4683 96.0873C70.2786 88.4773 81.1501 85.3898 91.179 85.7268C91.179 85.7268 92.8314 92.478 101.855 92.2171C110.878 91.9562 113.232 84.9006 113.232 84.9006C113.232 84.9006 124.859 84.8843 129.425 85.4714C136.252 86.3465 146.036 94.9839 160.37 131.887L137.872 138.372L135.187 191.354H119.836L69.8329 191.126L61.8152 124.984L61.8206 124.989Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.644 48.8074L84.1343 56.1836C84.1343 56.1836 81.585 51.5959 80.8022 47.905C79.9923 44.062 83.6669 37.9033 95.2721 36.2345C108.541 34.3266 113.302 44.6273 113.96 54.1344C114.069 55.6944 113.993 61.5596 113.226 65.3102C112.699 67.9085 111.688 70.2567 110.666 71.6809",
    fill: "#1F2025"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.644 48.8074L84.1343 56.1836C84.1343 56.1836 81.585 51.5959 80.8022 47.905C79.9923 44.062 83.6669 37.9033 95.2721 36.2345C108.541 34.3266 113.302 44.6273 113.96 54.1344C114.069 55.6944 113.993 61.5596 113.226 65.3102C112.699 67.9085 111.688 70.2567 110.666 71.6809",
    stroke: "#191A20",
    strokeWidth: 0.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0044 121.206H29.9347V191.354H87.0044V121.206Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.717 121.206H87.0044V191.354H119.717V121.206Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.062 141.296H102.349L87.0044 121.206H119.717L135.062 141.296Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.283 56.9012C32.283 56.9012 32.832 57.1403 33.7397 57.6241",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5772 59.3201C43.0077 63.5599 53.8085 73.4747 48.2314 89.9558C45.3396 98.4899 36.1804 96.7559 34.0931 92.092C32.4135 88.3414 35.1476 83.846 39.5071 84.4712C48.9652 85.8301 52.4006 99.4792 52.9605 117.923",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0094 119.575C53.0203 120.113 53.0311 120.657 53.0366 121.206",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6941 52.8189C83.6941 52.8189 84.928 64.609 88.5862 75.187C89.8799 78.9213 93.9459 79.6769 95.1961 79.7475C99.1098 79.9704 103.703 79.7149 110.672 71.6864L109.16 64.2829C109.16 64.2829 110.666 64.8265 111.161 63.2229C111.601 61.7988 111.52 58.4449 110.617 56.9284C110.46 56.6674 110.036 56.1565 109.313 56.0152C108.47 55.8521 107.823 56.6185 107.66 58.2982L106.122 50.7588C105.611 48.2638 103.524 46.3722 100.985 46.1874C100.947 46.1874 100.909 46.1819 100.871 46.1819C94.4786 45.7797 83.0853 48.0355 83.6995 52.8189H83.6941Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6252 74.502C94.0871 73.7139 94.2067 72.6485 94.897 72.1321C95.5874 71.6157 96.5875 71.8385 97.1257 72.6267C97.6638 73.4149 97.5388 74.4803 96.8539 74.9967C96.1636 75.5131 95.1634 75.2902 94.6252 74.502Z",
    fill: "#1F2025"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.918 45.1188C120.239 42.9406 120.813 37.9452 118.2 33.9614C115.587 29.9775 110.777 28.5138 107.456 30.692C104.134 32.8703 103.56 37.8657 106.173 41.8495C108.786 45.8334 113.597 47.2971 116.918 45.1188Z",
    fill: "#1F2025",
    stroke: "#191A20",
    strokeWidth: 0.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.93 132.876C156.93 132.876 163.925 148.656 164.659 151.374C165.393 154.092 165.502 158.533 153.315 165.594C140.34 173.112 111.563 189.43 109.139 191.354C106.714 193.278 102.985 199.295 101.018 199.899C99.05 200.502 98.7565 198.214 98.3868 198.138C98.0172 198.062 96.7616 199.317 95.3265 198.6C93.8915 197.882 95.0602 195.92 93.8045 196.072C92.5489 196.224 89.9723 197.165 90.0376 193.506C90.0539 192.729 88.4286 194.148 87.1512 192.158C85.7705 190 94.1633 185.244 93.9187 183.059C93.8045 182.015 89.581 178.776 89.0102 177.64C88.5373 176.688 89.744 175.204 91.7879 176.623C94.1905 178.292 96.7289 179.493 98.164 179.879C100.115 180.401 101.148 180.026 103.355 178.39C113.737 170.655 144.009 152.429 145.036 150.917C146.558 148.678 142.318 142.204 139.938 137.779L156.924 132.882L156.93 132.876Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7987 170.714C32.1579 170.774 34.6747 170.54 39.7516 171.176C43.3229 171.622 42.5456 175.123 40.8225 175.634C40.8225 175.634 43.9643 177.721 40.6485 179.276C40.6485 179.276 43.1327 181.754 39.8712 183.162C39.8712 183.162 41.0725 185.869 38.1535 186.293C35.2346 186.712 29.5977 186.424 28.7987 186.424C28.7987 186.424 27.3038 186.521 27.0701 183.14C26.8418 179.868 26.5102 170.676 28.7987 170.72V170.714Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5576 177.08H60.4291V185.907H80.5576V177.08Z",
    fill: "#C1E8FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.395 49.6064L21.3517 51.2208",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0796 52.3623L20.8571 52.2265",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2161 52.3406C23.2161 51.6394 25.4501 49.6608 27.1678 49.5358C28.8855 49.4107 30.114 50.2696 30.1955 51.4546C30.2771 52.6396 29.1954 53.6778 27.4777 53.7756C25.5099 53.8898 23.2215 52.9385 23.2161 52.3406V52.3406Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8736 53.0744C23.5477 52.8733 25.6132 54.3518 26.2166 55.9662C26.82 57.5806 26.3416 58.9994 25.2273 59.4125C24.113 59.8256 22.8138 59.0755 22.2322 57.4556C21.5691 55.5966 22.3029 53.2484 22.8736 53.0799V53.0744Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8464 52.6776C23.2976 51.9655 25.5371 52.2101 26.82 52.8135C28.1082 53.4169 28.6464 54.5258 28.2332 55.4118C27.8201 56.2978 26.6188 56.6131 25.3414 55.9934C23.8738 55.2868 22.3953 53.3897 22.8464 52.6776Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9713 53.4875C22.6588 53.4875 23.2161 52.9302 23.2161 52.2428C23.2161 51.5553 22.6588 50.998 21.9713 50.998C21.2839 50.998 20.7266 51.5553 20.7266 52.2428C20.7266 52.9302 21.2839 53.4875 21.9713 53.4875Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1306 136.67H51.5688V153.043H63.1306V136.67Z",
    fill: "#0C57BF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5941 141.296H14.5244L29.9347 121.206H87.0044L71.5941 141.296Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101.344 58.4123C101.784 60.8692 100.278 63.1903 97.9845 63.598C95.6907 64.0057 93.4729 62.3478 93.038 59.8908C92.5977 57.4339 94.1034 55.1128 96.3973 54.7051C98.4031 54.3464 100.349 55.5694 101.099 57.5263C101.208 57.8089 101.289 58.1025 101.344 58.4123V58.4123Z",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6953 60.0648C91.1356 62.5217 89.6299 64.8428 87.336 65.2505C85.0421 65.6581 82.8243 64.0002 82.3895 61.5433C81.9492 59.0863 83.4549 56.7653 85.7487 56.3576C87.7545 55.9989 89.7005 57.2219 90.4506 59.1788C90.5594 59.4614 90.6409 59.7549 90.6953 60.0648Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M101.496 58.4123L108.003 56.8251",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2723 68.1423L93.8316 68.6804C93.3587 68.7837 92.8967 68.4956 92.788 68.0281C92.3422 66.1147 91.7715 62.4347 91.0214 57.7491",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7714 60.0593C90.7714 60.0593 91.69 59.3255 93.0326 59.8908",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0385 59.8908C96.1092 59.3418 96.6147 58.9559 97.1637 59.032C97.7127 59.1081 98.0986 59.6082 98.0225 60.1572C97.9464 60.7062 97.4464 61.0921 96.8973 61.016C96.3483 60.9399 95.9624 60.4398 96.0385 59.8908Z",
    fill: "#1F2025"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7868 61.3693C85.8575 60.8203 86.363 60.4344 86.912 60.5105C87.461 60.5866 87.8469 61.0867 87.7708 61.6357C87.6947 62.1847 87.1946 62.5706 86.6456 62.4945C86.0966 62.4184 85.7107 61.9183 85.7868 61.3693Z",
    fill: "#1F2025"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthentication);
export default __webpack_public_path__ + "static/media/authentication.6fccd44c2f624398fb141fc7640e78f3.svg";
export { ForwardRef as ReactComponent };